export const ModelTemplate = {
  shared: "shared",
  order: "order",
  reserved: "reserved"
};
